import { render } from "./locationArrowSVG.vue?vue&type=template&id=4502b1ac"
import script from "./locationArrowSVG.vue?vue&type=script&lang=js"
export * from "./locationArrowSVG.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__